// Shared auth helpers used across pages/components.

// Returns true when the user is considered logged in.
// User is logged in if LOGIN === "Success" OR both CUSTOMERID and
// CUSTOMERUSERCODE exist in localStorage.
export function isUserLoggedIn() {
  const loginStatus = localStorage.getItem("LOGIN") || null;
  const customerId = localStorage.getItem("CUSTOMERID") || null;
  const customerUserCode = localStorage.getItem("CUSTOMERUSERCODE") || null;

  return loginStatus === "Success" || Boolean(customerId && customerUserCode);
}
